import { Component, EventEmitter, Input, Output, ViewChild, ElementRef, } from '@angular/core';
var InputSearchComponent = /** @class */ (function () {
    function InputSearchComponent() {
        /**
         * @type KEY_ENTER_CODE - A reference to the Enter Key {keyCode} property regarding IE
         */
        this.KEY_ENTER_CODE = 13;
        /**
         * @type searchChange {EventEmitter<string>} - Update search results
         */
        this.searchChange = new EventEmitter();
        /**
         * @type _shouldFocus boolean - should auto focus input
         */
        this._shouldFocus = true;
    }
    /**
     * Lifecycle Hook
     */
    InputSearchComponent.prototype.ngAfterViewInit = function () {
        this.onFocusSearchInput(1000);
    };
    /**
     * onKeyUp {function} - Fires keyUp events when typing in search input field
     * @param {KeyboardEvent} event - indicates whether Enter or NumpadEnter is pressed
     */
    InputSearchComponent.prototype.onKeyUp = function (event) {
        // Due to IE11 (cross browser) support we need to use keyCode property instead of W3C recommendation
        var keyCode = window.event ? event.which : event.keyCode;
        if (keyCode === this.KEY_ENTER_CODE) {
            this.searchChanged();
        }
    };
    /**
     * searchChanged {function} - Start and emit search changes
     */
    InputSearchComponent.prototype.searchChanged = function () {
        var _this = this;
        // if(this.searchText !== undefined && this.currentSearchTerm !== this.searchText) {
        if (this.searchText !== undefined) {
            this.searchChange.emit(this.searchText);
            this.currentSearchTerm = this.searchText;
        }
        else {
            this.onFocusSearchInput(1);
            setTimeout(function () {
                _this.searchInput.nativeElement.select();
            }, 1);
        }
    };
    /**
     * onSearchClearIconClick - Empties the input field when the delete cross is clicked
     */
    InputSearchComponent.prototype.onSearchClearIconClick = function () {
        this.searchText = '';
        this.onFocusSearchInput(1);
    };
    /**
     * onFocusSearchInput - Focus the input field
     * Use setTimeout() for nativeElement: https://stackoverflow.com/questions/41873893/angular2-autofocus-input-element
     */
    InputSearchComponent.prototype.onFocusSearchInput = function (delay) {
        var _this = this;
        setTimeout(function () {
            if (_this.shouldFocus) {
                _this.searchInput.nativeElement.focus();
            }
        }, delay);
    };
    Object.defineProperty(InputSearchComponent.prototype, "isFocused", {
        get: function () {
            return this._isFocused;
        },
        set: function (isFocused) {
            this._isFocused = isFocused;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSearchComponent.prototype, "searchText", {
        get: function () {
            return this._searchText;
        },
        set: function (value) {
            this._searchText = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSearchComponent.prototype, "shouldFocus", {
        get: function () {
            return this._shouldFocus;
        },
        set: function (value) {
            this._shouldFocus = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InputSearchComponent.prototype, "currentSearchTerm", {
        get: function () {
            return this._currentSearchTerm;
        },
        set: function (text) {
            this._currentSearchTerm = text;
        },
        enumerable: true,
        configurable: true
    });
    InputSearchComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-input-search',
                    template: "<div class=\"a-input-search\"\r\n\t data-t-name=\"InputSearch\">\r\n\t<div class=\"a-input-search__search-box\"\r\n\t\t [ngClass]=\"{'a-input-search__search-box--is-focused': isFocused }\">\r\n\t\t<input type=\"text\" #searchInput\r\n\t\t\t   class=\"a-input-search__input\"\r\n\t\t\t   [(ngModel)]=\"searchText\"\r\n\t\t\t   (keyup)=\"onKeyUp($event)\"\r\n\t\t\t   (focus)=\"isFocused = true\"\r\n\t\t\t   (blur)=\"isFocused = false\"/>\r\n\t\t<div class=\"a-input-search__search-box--input-wrapper\" (mousedown)=\"searchChanged()\">\r\n\t\t\t<span class=\"a-input-search__search-box--input-wrapper-icon\"></span>\r\n\t\t</div>\r\n\t\t<div class=\"a-input-search__search-box--clear-icon-wrapper\" (mousedown)=\"onSearchClearIconClick()\"\r\n\t\t\t *ngIf=\"searchText && isFocused\">\r\n\t\t\t<span class=\"a-input-search__search-box--clear-icon-wrapper-clear-icon\"></span>\r\n\t\t</div>\r\n\t</div>\r\n</div>\r\n"
                }] }
    ];
    InputSearchComponent.propDecorators = {
        searchChange: [{ type: Output }],
        _shouldFocus: [{ type: Input }],
        searchInput: [{ type: ViewChild, args: ['searchInput',] }],
        searchText: [{ type: Input }],
        shouldFocus: [{ type: Input }]
    };
    return InputSearchComponent;
}());
export { InputSearchComponent };
//# sourceMappingURL=input-search.component.js.map